export function debounce(fn, delay = 300) {
    let timer = null;
    return function() {
        let content = this;
        let args = arguments;
        if (timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            fn.apply(content, args);
        }, delay);
    };
}

export const extractArray = (value, str = ",") => {
    return value ? value.split(str).filter(Boolean) : [];
};

export const isHttp = (str) => {
    var reg = /(http|https):\/\/[\w.-]+(\/[^\s]*)?/;
    return reg.test(str);
};

export const forData = (obj, array) => {
    array.forEach((element) => {
        obj[element] = Array.isArray(obj[element]) ? obj[element] : extractArray(obj[element]);
    });
    return obj;
};

export const formatEnterpriseTypeList = (list = []) =>
    (list || []).map(item => {
        if (item == null || typeof item === "string" || typeof item === "number") {
            return { id: item, name: item == null ? "" : String(item) };
        }
        return {
            id: item.key != null ? item.key : item.id,
            name: item.value || item.name || item.label || "",
        };
    });

export async function fetchEnterpriseConfigLists(http) {
    const { data: res } = await http.get("/admin/Common/getConfigDictionaries?config=enterprise");
    if (res.errorCode == 200) {
        return {
            typeList: formatEnterpriseTypeList(res.data.enterpriseType),
            businessList: formatEnterpriseTypeList(res.data.enterpriseBusiness),
        };
    }
    return { typeList: [], businessList: [] };
}

export async function fetchEnterpriseTypeList(http) {
    const { typeList } = await fetchEnterpriseConfigLists(http);
    return typeList;
}

export async function fetchEnterpriseBusinessList(http) {
    const { businessList } = await fetchEnterpriseConfigLists(http);
    return businessList;
}
